import React, { memo, useContext, useEffect, useState } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { RetornoLoteContext } from "../../Context/RetornoLoteContext";

function SelectSituacao({ row }) {
  const { setGlosas, setAtualizaValoresRecebimentoManual } =
    useContext(RetornoLoteContext);

  const { id, situacao } = row;
  const [situacaoAtual, setSituacaoAtual] = useState("");

  useEffect(() => {
    setSituacaoAtual(situacao);
  }, [situacao]);

  function alteraSituacao(estado) {
    setGlosas((prevState) => {
      const novaSituacao = prevState;
      const resultado = novaSituacao.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            situacao: estado,
          };
        }
        return { ...item };
      });

      return resultado;
    });
    setSituacaoAtual(estado);
    setAtualizaValoresRecebimentoManual((prevState) => !prevState);
  }

  return (
    <FormControl variant="standard" fullWidth>
      <Select
        value={situacaoAtual}
        onChange={(e) => alteraSituacao(e.target.value)}
        sx={{
          "& .MuiSelect-select": {
            padding: "4px",
          },
          "& .MuiSelect-icon": {
            right: 6,
          },
          backgroundColor: "rgba(255,255,255,0.9)",
          border: "0.5px solid #e0e0e0",
        }}
      >
        <MenuItem value="EmAnalise">Em Análise</MenuItem>
        <MenuItem value="Analise">Em Recurso</MenuItem>
        <MenuItem value="Glosado">Glosado</MenuItem>
        <MenuItem value="Acatado">Glosado Acatado</MenuItem>
      </Select>
    </FormControl>
  );
}

export default memo(SelectSituacao);
